// extracted by mini-css-extract-plugin
module.exports = {"walkTime":"WalkTime_walkTime__BpmlS","icon":"WalkTime_icon__zjfXL","text":"WalkTime_text__X2kAL"};